


























import BaseFormEdit from "../../models/base.form.edit";
import { Component } from "vue-property-decorator";

@Component({})
export default class Edit extends BaseFormEdit {
  form = { name: "" } as any;
  urlPrefix = "pmdd";
}
